/* eslint-disable max-classes-per-file */
import React from 'react'
import PropTypes from 'prop-types'

// prettier-ignore
export class ContextConsumerComponent<P = {}, S = {}> extends React.Component<P, S> {
  static contextTypes = {
    getApp: PropTypes.func,
    getAssetURL: PropTypes.func,
    getBaseURL: PropTypes.func,
    getDatasources: PropTypes.func,
    getFlags: PropTypes.func,
    getStore: PropTypes.func,
    appVersion: PropTypes.string,
    getParams: PropTypes.func,
    getBinding: PropTypes.func,
    getBindings: PropTypes.func,
    getBindingsList: PropTypes.func,
  }
}

export class BindingContextConsumerComponent<
  P = {},
  S = {}
> extends ContextConsumerComponent<P, S> {
  static contextTypes = {
    getApp: PropTypes.func,
    getAssetURL: PropTypes.func,
    getBaseURL: PropTypes.func,
    getDatasources: PropTypes.func,
    getFlags: PropTypes.func,
    getStore: PropTypes.func,
    appVersion: PropTypes.string,
    getParams: PropTypes.func,
    getBinding: PropTypes.func,
    getBindings: PropTypes.func,
    getBindingsList: PropTypes.func,
  }
}
